function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "56.272 38.353 53.53 37.454 51.037 37.729 50.677 38.048 50.072 39.074 50.331 40.577 52.601 40.821 53.292 40.079 54.181 40.404 56.014 40.709 58.567 40.435 59.502 39.368 59.151 38.627"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "56.907 43.857 56.095 43.36 54.479 43.594 54.231 44.533 55.028 45.909 55.328 47.209 57.11 47.514 57.842 47.29 58.05 46.036 57.872 44.649"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m72.751 47.981 0.34-1.133-1.508-1.671-1.641-0.472-1.559-1.336-2.031-0.259-1.468 0.66-0.827-0.27-0.874-1.239-1.401-0.853-1.133 0.386-0.467 1.178 0.305 1.844 1.427 1.092 1.823 0.355 0.65 1.229 0.36 2.474 0.01 0.681 0.681 0.573 1.706-0.243 1.412-1.047 1.198-0.497 2.011-0.366 0.986-1.086z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m41.5 32.798-0.878-0.945-0.762-2.184-0.544-1.995-0.472-0.427-0.533 0.046-1.052 0.599-0.518 0.92-0.686 0.695-1.179 0.478-0.568 0.939 0.325 1.559 1.604 2.702 0.808 0.781 0.594-0.294 0.559-0.854 1.295-0.203 0.528 1.066 0.868 1.062 1.066 0.274 1.514-0.249 0.528-1.138-1.087-2.29-1.41-0.542z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m92.362 72.133-1.066-0.411-1.828-2.697-1.473-1.416-0.518-2.575-2.199-2.066-3.047-2.169-3.854-1.676-2.723-2-1.086-0.574-0.579 0.513v3.164l1.056 1.625-0.365 1.544-1.838 1.858-1.128 2.554 0.392 1.89 1.335 2.899 0.579 2.28-0.386 4.266 0.472 2.209 1.523 1.625 2.082 1.355h0.63l0.995-2.219 1.996-3.021 2.62-1.452 3.388-0.569 2.711-1.457 2.539-2.514-0.228-0.966z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m14.434 16.807-3.474 0.508-1.808 0.929-1.016 1.32-0.381 1.885 1.097 1.335 2.026 0.538 2.052 0.965 0.371 0.519 0.797-0.233 1.401-1.828 0.401-1.696v-2.55l-0.858-1.518-0.608-0.174z"
});

var SvgHawaii = function SvgHawaii(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    enableBackground: "new 0 0 100 100",
    fill: "#000000",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHawaii, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Hawaii.4387ae72.svg";
export { ForwardRef as ReactComponent };